<template>
  <div class="app-container">
    <PageTitle
      title="产品价格管理"
      ref="pageTitle"
      v-model="listQuery.city"
      @onChange="changeCity"
    />
    <div class="filter-container">
      <el-select
        clearable
        v-model="listQuery.project_name"
        filterable
        placeholder="请选择项目名称"
        style="width: 160px; margin-right: 10px"
        @change="changeProject"
      >
        <el-option
          v-for="item in project_options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入套餐名称"
        v-model="listQuery.name"
        @change="handleName"
      ></el-input>
      <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.platform"
        placeholder="所属平台"
        @change="handlePlatform"
      >
        <el-option
          v-for="item in platform_options"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-button
        class="filter-item"
        type="primary"
        plain
        icon="el-icon-refresh-left"
        @click="handleReset"
        >重置</el-button
      >
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="$refs.edit.handleCreate()"
        >新增</el-button
      >
    </div>
    <div v-for="(platformItem, index) in list" :key="index" style="margin-bottom: 20px">
      <div style="background-color: #d3dce6; padding: 10px; font-weight: bold; text-align: center">
        平台: {{ platformItem.platform_name }}
      </div>
      <el-table :data="platformItem.items" style="width: 100%" border>
        <el-table-column prop="project_name" label="项目名称" align="center"></el-table-column>
        <el-table-column prop="full_group_num" label="满团人数" align="center"></el-table-column>
        <el-table-column prop="package_name" label="套餐名称" align="center"></el-table-column>
        <el-table-column
          prop="off_season_per_price"
          label="成人淡季价格(单人)"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="old_off_season_per_price"
          label="老人淡季价格(单人)"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="child_off_season_per_price"
          label="儿童淡季价格(单人)"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="peak_season_per_price"
          label="成人旺季价格(单人)"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="old_peak_season_per_price"
          label="老人旺季价格(单人)"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="child_peak_season_per_price"
          label="儿童旺季价格(单人)"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="off_season_package_price"
          label="淡季价格(一口价)"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="peak_season_package_price"
          label="旺季价格(一口价)"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="$refs.edit.handleEdit(scope.row.id, 'edit')"
              >修改</el-button
            >
            <el-button type="text" @click="handleDel(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>
    <Edit ref="edit" />
  </div>
</template>

<script>
import { getList as getProjectList } from '@/api/projects'
import { getList, del } from '@/api/productsPrice'
import PageTitle from '@/components/PageTitle'
import Edit from './components/Edit'
import { PLATFORM_OPTIONS } from '@/utils/platform'
export default {
  name: 'ProductsIndex',
  components: {
    PageTitle,
    Edit
  },
  data() {
    return {
      list: null,
      count: 0,
      listLoading: true,
      listQuery: {
        name: '',
        project_id: '',
        project_name: '',
        page: 1,
        size: 3,
        city: '',
        platform: ''
      },
      project_options: [],
      platform_options: PLATFORM_OPTIONS,

      uuids: []
    }
  },
  created() {
    getProjectList({ size: 1000 }).then((res) => {
      this.project_options = res.data.results
    })
    this.fetchData()
  },
  mounted() {
    this.listQuery.city = this.$refs.pageTitle.city
  },
  methods: {
    // 获取数据
    fetchData() {
      this.listLoading = true
      getList(this.listQuery).then((res) => {
        this.list = res.data.results
        this.count = res.data.count
        this.listLoading = false
      })
    },
    /**
     * @description: 选择城市
     * @param {*} e
     * @return {*}
     */
    changeCity(e) {
      this.listQuery.city = e
      this.handleFilter()
    },
    /**
     * @description: 选择行
     * @return {*}
     */
    changeSelect(e) {
      this.uuids = e.map((item) => item.id)
    },
    /**
     * @description: 选择项目名称
     * @param {*} e
     * @return {*}
     */
    changeProject(value) {
      if (!value) {
        this.listQuery.project_id = ''
        this.listQuery.project_name = ''
        this.user_limit = ''
        this.handleFilter()
        return
      }
      let list = this.project_options.filter((item) => item.id === value)

      this.listQuery.project_id = value
      this.listQuery.project_name = list[0].name
      this.user_limit = list[0].user_limit
      this.handleFilter()
    },
    // 筛选
    handleFilter() {
      if (!this.listQuery.name && !this.listQuery.project_id) {
        this.$message.warning('套餐名称和项目名称，二者必须要填一个')
        return
      }
      this.listQuery.page = 1
      this.fetchData()
    },
    handlePlatform(value) {
      this.listQuery.platform = value
      this.handleFilter()
    },
    handleName(value) {
      this.listQuery.name = value
      this.handleFilter()
    },

    handleReset() {
      this.listQuery = {
        page: 1,
        size: 3,
        city: this.$refs.pageTitle.city,
        name: '',
        project_id: '',
        project_name: '',
        platform: ''
      }
      this.fetchData()
    },

    // 删除
    handleDel(uuid) {
      this.$confirm('确认删除该项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          del(uuid).then(() => {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            })
            this.fetchData()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
.filter-container {
  justify-content: flex-start !important;
  flex-wrap: wrap;
}
</style>
